













import { Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Routes } from '@/router/routes'

@Component
export default class LimitsTableHeader extends Vue {
  routes = Routes
}
